import { render } from "./HeaderMenuIcon.vue?vue&type=template&id=009fce17&scoped=true"
import script from "./HeaderMenuIcon.vue?vue&type=script&lang=js"
export * from "./HeaderMenuIcon.vue?vue&type=script&lang=js"

import "./HeaderMenuIcon.vue?vue&type=style&index=0&id=009fce17&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009fce17"]])

export default __exports__